/**
*
*   Content Block
*       - A left/right content block + image or video
*
**/
'use client';

import Config from '@/config';
import Batch from '@/components/batch';
import Image from '@/components/image';
import Button from '@/components/button';
import { useState, useLayoutEffect, useRef } from 'react';
import { useLocale, useTranslations } from 'next-intl';


//Build the Element
export default function ProductBatch({ product, ...props }){

    const ref   = useRef();
    const t     = useTranslations();

    //
    const photo = (
        product.productType.toLowerCase().replace(/^[0-9]+/g,'-') == 'essential-oil-blend' ?
        'blend-batch-number.jpg'
        :
        'blend-batch-number.jpg'
    );

    //Return
    return (
        <div id="batch" className="grid auto container" ref={ ref }>
            <div className="col">

                <section className="lookup">
                    <Image src={ 'product/' + photo } alt="" width="1000" height="1000" />
                    <header>
                        <h2>{ t('Pages.Product.Batch.title') }</h2>
                        <div>{ 
                            t.rich('Pages.Product.Batch.description',{ 
                                ...Config.i18n.html,
                                p:      (chunks) => <p>{ chunks }</p>,
                                name:   product.title 
                            }) 
                        }</div>
                    </header>
                    <Batch />
                </section>
            </div>
            <div className="col">

            </div>
            <div className="col">
                <section className="batch-info">
                    <ol>
                        <li>
                            <strong>{ t('Components.Batch.popups.process.steps.locate.title') }</strong>
                        </li>
                        <li>
                            <strong>{ t('Components.Batch.popups.process.steps.search.title') }</strong>
                            <p>{ t('Components.Batch.popups.process.steps.search.description') }</p>
                        </li>
                        <li>
                            <div data-destination={ String( typeof props.destination !== 'undefined' ) ? "1" : "0" } data-offset="250" className="arrow">
                                <div>
                                    <div></div>
                                </div>
                            </div>
                            <strong>{ t('Components.Batch.popups.process.steps.submit.title') }</strong>
                            <p>{ t('Components.Batch.popups.process.steps.submit.description') }</p>
                        </li>
                    </ol>
                </section>
            </div>
        </div>
    );

}